import { render, staticRenderFns } from "./SettingsPassword.vue?vue&type=template&id=22c81872&scoped=true"
import script from "./SettingsPassword.vue?vue&type=script&lang=js"
export * from "./SettingsPassword.vue?vue&type=script&lang=js"
import style0 from "./SettingsPassword.vue?vue&type=style&index=0&id=22c81872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c81872",
  null
  
)

export default component.exports